import { BaseViewStore, BaasicDropdownStore } from 'core/stores';
import { applicationContext, QueryUtility, uuid } from 'core/utils';
import { ModalParams } from 'core/models';
import { FacilityOrderService, FacilityOrderTemplateService, FacilityOrderStatusService, FacilityOrderTemplateItemService, ItemSubcategoryService } from "application/facility-order/services";
import { LookupService } from "common/services";
import { PickTicketHeaderService } from "application/pick-ticket/services";
import { ItemCategoryService } from 'application/product/services';
import { FacilityOrderPatientService } from "application/facility-order-new-flow-insurance/services";
import { FacilityInventoryCountDetailService } from "application/facility-inventory/services";
import { ScheduleService } from 'application/schedule/services';
import { PersonService } from 'application/person/services';
import { LocalPatientService } from "application/patient/services";
import { action, observable } from 'mobx';
import _ from 'lodash';
@applicationContext
class FacilityOrderNewFlowUSIntakeSinglePagePreviewViewStore extends BaseViewStore {
    tabItems = [{ abrv: 'in-progress', name: 'In Progress' }, { abrv: 'discharge', name: 'Discharges' }, { abrv: 'intake-reviewed', name: 'Intake Reviewed' }];
    inactiveOptions = [{ id: "15", name: "Hospital" }, { id: "17", name: "Discharged" }, { id: "18", name: "Expired" }, { id: "0", name: "Active" }];
    questions = [{ id: "0", name: "Insurance questions" }, { id: "1", name: "Product questions" }];

    @observable accessor facilityOrder;
    @observable accessor facilityOrderStatus;
    @observable accessor facilityOrderPatients = [];
    @observable accessor selectedStatusAbrv;
    @observable accessor pickTicketHeaderStatus;
    @observable accessor loadingTemplates = true;
    @observable accessor selectedQuestions = [];
    @observable accessor itemCategories = [];
    @observable accessor allFacilityOrderTemplates = [];
    @observable accessor facilityOrderTemplatesGroupByPatient;
    @observable accessor disabled = false;
    @observable accessor isEmpty = false;
    @observable accessor isReviewed = undefined;
    @observable accessor isStatusBarVisible = true;
    @observable accessor lookups;
    @observable accessor isLoadMore = false;
    @observable accessor totalRecords;
    @observable accessor showLoader = false;
    @observable accessor groupByPatient;
    @observable accessor templatesToRemove = [];

    constructor(rootStore) {
        super(rootStore);

        this.id = rootStore.routerStore.routerState.params.id;
        this.isAdmin = rootStore.userStore.user.roles.includes("Administrators");
        this.hasMore = false;

        this.facilityOrderTemplateService = new FacilityOrderTemplateService(rootStore.application.baasic.apiClient);
        this.itemCategoryService = new ItemCategoryService(rootStore.application.baasic.apiClient);
        this.facilityOrderStatusService = new FacilityOrderStatusService(rootStore.application.baasic.apiClient);
        this.localPatientService = new LocalPatientService(rootStore.application.baasic.apiClient);
        this.facilityOrderPatientService = new FacilityOrderPatientService(rootStore.application.baasic.apiClient);
        this.itemSubcategoryService = new ItemSubcategoryService(rootStore.application.baasic.apiClient);
        this.facilityOrderTemplateItemService = new FacilityOrderTemplateItemService(rootStore.application.baasic.apiClient);
        this.scheduleService = new ScheduleService(rootStore.application.baasic.apiClient);

        this.queryUtility = new QueryUtility(this.rootStore, async filter => {
            await this.fetchFacilityOrderTemplates(filter);
        }, {});

        this.questionsStore = new BaasicDropdownStore(
            {
                multi: true,
                filterable: false,
            },
            {
                fetchFunc: () => {
                    return this.questions;
                },
            }
        );

        this.itemCategoryStore = new BaasicDropdownStore({
            multi: true, filterable: true, initFetch: false
        }, {
            fetchFunc: async (term) => {
                const response = await this.itemCategoryService.find({
                    searchQuery: term,
                    rpp: 100
                });
                let filteredCategories = response.data.item.filter(i => this.facilityOrder.isEnteralWeek ? i.abrv === "enteral" : (i.abrv === "enteral" || i.abrv === "respiratory" || i.abrv === "urological"
                    || i.abrv === "ostomy" || i.abrv === "wound-care"));
                return filteredCategories;
            },
        });

        this.facilityOrderTemplateNewFlowUSIntakeTemplateActivationModal = new ModalParams({});
        this.createFacilityOrderTemplateUSIntakeNewFlowModal = new ModalParams({});
        this.facilityOrderPatientNewFlowUSIntakeEligibilityStatusNoteModal = new ModalParams({});
        this.facilityOrderPatientNewFlowInsuranceNoteModal = new ModalParams({});
        this.facilityOrderTemplateNewFlowUSIntakeInsuranceQuestionModal = new ModalParams({});
        this.facilityOrderPatientNewFlowInsuranceEditModal = new ModalParams({});
        this.facilityOrderPatientNewFlowUSIntakeInsuranceInfoModal = new ModalParams({});
        this.facilityOrderTemplateNewFlowInsuranceHistoryOfChangesModal = new ModalParams({});
        this.facilityOrderTemplateItemNewFlowCalculationModal = new ModalParams({});
        this.facilityOrderTemplateNewFlowUSIntakeMissingProductNoteModal = new ModalParams({});
        this.facilityOrderTemplateNewFlowUSIntakePortalNoteModal = new ModalParams({});
        this.facilityOrderTemplateDoNotSupplyModal = new ModalParams({});
        this.facilityOrderTemplateNewFlowUSIntakeClinicalInformationModal = new ModalParams({});
        this.facilityOrderTemplateNewFlowDeleteModal = new ModalParams({});
        this.facilityOrderTemplateItemNewFlowDeleteQuestionModal = new ModalParams({});
        this.facilityOrderNewFlowUSIntakeFindAndReplaceModal = new ModalParams({});
        this.facilityOrderTemplateNewFlowInvoiceNoteModal = new ModalParams({});

        this.templateChangeConfirmModal = new ModalParams({ onClose: null });
        this.templateChangeConfirmModal.onConfirm = async () => { this.templateChangeConfirmModal.close(); };
        this.templateChangeConfirmModal.yesLabel = 'MODAL.ACKNOWLEDGE';
        this.templateChangeConfirmModal.doNotShowCancel = true;

        this.statusConfirmModal = new ModalParams({ onClose: null });
        this.statusConfirmModal.onConfirm = async () => { await this.setUSIntakeStarted(); this.statusConfirmModal.close(); };
        this.statusConfirmModal.onCancel = () => { this.statusConfirmModal.close() };
        this.statusConfirmModal.yesLabel = 'MODAL.START_ANYWAYS_LABEL';
        this.statusConfirmModal.noLabel = 'MODAL.CANCEL_LABEL';
        this.statusConfirmModal.swapButtons = true;

        this.fetch([
            this.initialize()
        ]);
    }

    async initialize() {
        await this.initializeFacilityOrder();
        await this.initializeFacilityOrderPatients();
        await this.itemCategoryStore.filterAsync();
        await this.initializePickTicketHeader();
        await this.initializeLookups();
        await this.initializeStatus();
        this.fetchAllFacilityOrderTemplates();

        const typeResponse = await this.scheduleService.getTypes();
            this.orderType = _.find(typeResponse.item, {abrv: 'ordering'});
    }

    @action.bound
    async initializeFacilityOrder() {
        const facilityOrderService = new FacilityOrderService(this.rootStore.application.baasic.apiClient);
        this.facilityOrder = (await facilityOrderService.get(this.id, { embed: 'Facility,Facility.FacilityAreaOfCares,FacilityOrderStatuses' })).data;
        this.isInventoryStepAllowed = (await facilityOrderService.isInventoryStepAllowed(this.id)).data;
        const masterPatient = (await this.localPatientService.getByPatientKey(this.facilityOrder.facility.masterPatientId, { fields: 'id' })).data; 
        this.masterPatientId = masterPatient ? masterPatient.id : undefined;
        this.rootStore.titleStore.setTitle(`US Intake - ${this.facilityOrder.facility.name}`);
        this.facilityOrderStatus = this.facilityOrder.facilityOrderStatuses.find(i => i.status.abrv === 'us-intake');
        this.disabled = !(this.facilityOrderStatus && this.facilityOrderStatus.startedOn);
    }

    @action.bound
    async initializeFacilityOrderPatients() {
        this.facilityOrderPatients = (await this.facilityOrderPatientService.find({ rpp: 10000, facilityOrderId: this.facilityOrder.id, embed: "EligibilityStatus,FacilityOrderPatientInitial,FacilityOrderPatientInitial.EligibilityStatus" })).data.item;
    }

    @action.bound
    async initializePickTicketHeader() {
        if (!this.facilityOrder.pickTicketHeaderId) {
            const facilityOrderService = new FacilityOrderService(this.rootStore.application.baasic.apiClient);
            this.facilityOrder.pickTicketHeaderId = (await facilityOrderService.get(this.id, { fields: 'PickTicketHeaderId' })).data.pickTicketHeaderId;
        }

        if (this.facilityOrder.pickTicketHeaderId) {
            const pickTicketHeaderService = new PickTicketHeaderService(this.rootStore.application.baasic.apiClient);
            const pickTicketHeader = (await pickTicketHeaderService.get(this.facilityOrder.pickTicketHeaderId, { embed: "pickTicketHeaderStatus" })).data;
            this.pickTicketHeaderStatus = pickTicketHeader && pickTicketHeader.pickTicketHeaderStatus && pickTicketHeader.pickTicketHeaderStatus.abrv;
        }
    }

    @action.bound
    async initializeLookups() {
        const lookupService = new LookupService(this.rootStore.application.baasic.apiClient);
        this.lookups = await lookupService.getLookups("NewFlowStatus,ItemCategory,SubCategory,ImportAction,ImportDetailStatus,ImportHeaderStatus,SpecialtyType,FacilityScheduleType");
        this.enteralItemCategoryId = _.find(this.lookups.itemCategory, s => { return s.abrv === 'enteral'; }).id;
    }

    @action.bound
    async initializeStatus() {
        let queryParams = this.rootStore.routerStore.routerState.queryParams;
        const selectedStatus = _.find(this.lookups.newFlowStatus, s => {
            return queryParams && queryParams.newFlowUSIntakeStatusIds && s.id === queryParams.newFlowUSIntakeStatusIds;
        });
        let openIntakeReviewedTab = false;
        if (this.facilityOrderStatus && this.facilityOrderStatus.completedOn) {
            openIntakeReviewedTab = !(await this.hasAnyTemplateInProgress());
        }
        const selectedStatusAbrv = selectedStatus ? selectedStatus.abrv : openIntakeReviewedTab ? 'intake-reviewed' : 'in-progress';
        this.setStatus(selectedStatusAbrv, false);
    }

    @action.bound
    setStatus(statusAbrv, fetch = true) {
        if (this.selectedStatusAbrv == statusAbrv || this.showLoader) {
            return;
        }
        this.isEmpty = false;
        this.isLoadMore = false;

        this.loadingTemplates = true;
        this.facilityOrderTemplatesGroupByPatient = [];
        this.selectedStatusAbrv = statusAbrv;

        if(this.selectedStatusAbrv === "in-progress")
        {
            this.templatesToRemove = [];
        }

        const statusIds = _.map(_.filter(this.lookups.newFlowStatus, s => this.selectedStatusAbrv === "in-progress" ? (s.abrv === "in-progress" || s.abrv === "change" || s.abrv === "no-change" || s.abrv === "new-order") : s.abrv === this.selectedStatusAbrv), (s => { return s.id }));
        this.queryUtility.filter.set('newFlowUSIntakeStatusIds', statusIds.join(","));

        if (fetch) {
            this.queryUtility.fetch();
        }
    }

    @action.bound
    async fetchAllFacilityOrderTemplates() {
        this.loadingTemplates = true;
        let params = {
            pageSize: 10000,
            facilityOrderId: this.id,
            embed: 'FacilityOrderTemplateInitial,FacilityOrderTemplateInitial.OrderingDoctor,FacilityOrderTemplateInitial.ClinicalStatus,FacilityOrderTemplateItems,Patient,SubCategory,ItemCategory,ImportReference,NewFlowStatus,NewFlowInsuranceStatus,NewFlowUSIntakeStatus,ReviewUSIntakeValidations,FacilityOrderTemplateMissingDocuments,FacilityOrderTemplateMissingDocumentInitials,OrderingDoctor,ClinicalStatus,IsFacilityOrderTemplateItemInitial,ImportDetailStatus',
            orderBy: "SubCategory",
            orderDirection: "asc",
            itemCategoryIds: this.facilityOrder.isEnteralWeek ? [this.enteralItemCategoryId] : undefined,
            masterPatientId: this.facilityOrder.isEnteralWeek ? this.masterPatientId : undefined
        }

        let items = (await this.facilityOrderTemplateService.find(params)).data.item;
        this.allFacilityOrderTemplates = _.map(items, (template) => {
            return {
                ...template,
                itemsVisible: template.inactiveReasonId === 58 ? true : false
            };
        });

        this.queryUtility.fetch();
        this.loadingTemplates = false;
    }

    @action.bound
    async fetchFacilityOrderTemplates(filter) {
        let showInfoMessage = this.filterChange;
        this.loadingTemplates = true;
        if (this.selectedStatusAbrv != "in-progress" || this.filterChange) {
            this.filterChange = false;
            this.facilityOrderTemplatesGroupByPatient = [];
        }

        const newFlowUSIntakeStatusIds = filter.newFlowUSIntakeStatusIds.split(",");
        const itemCategoryIds = this.facilityOrder.isEnteralWeek ? [this.enteralItemCategoryId] : _.map(this.itemCategories, (i => { return i.id }));
        const showInsuranceQuestionPatients = this.selectedStatusAbrv != "discharge" && this.selectedQuestions.some(x => x.id === "0");
        const showMissingProductTemplates = this.selectedStatusAbrv != "discharge" && this.selectedQuestions.some(x => x.id === "1");

        let filterTemplates =
            this.allFacilityOrderTemplates.filter(t =>
                newFlowUSIntakeStatusIds.includes(t.newFlowUSIntakeStatusId) &&
                (itemCategoryIds.length == 0 || itemCategoryIds.includes(t.itemCategoryId) || this.masterPatientId == t.patientId) &&
                (!showInsuranceQuestionPatients || this.hasPatientInsuranceQuestion(t.patientId)) &&
                (!showMissingProductTemplates || t.missingProduct)
            );

        let groupByPatient = _.groupBy(filterTemplates, 'patientId');
        this.totalRecords = Object.values(groupByPatient).length;
        this.groupByPatient = Object.values(groupByPatient);
        if (this.selectedStatusAbrv == "in-progress") {
            let index = 0;
            const indexStart = this.facilityOrderTemplatesGroupByPatient.length;
            const indexEnd = indexStart + 5;
            _.each(groupByPatient, (val, key) => {
                if (index >= indexStart && index < (indexEnd)) {
                    let facilityOrderPatient = this.facilityOrderPatients.find(x => x.patientId == key);
                    this.facilityOrderTemplatesGroupByPatient.push({ id: `${this.selectedStatusAbrv}-${key}-${uuid()}`, facilityOrderPatient: facilityOrderPatient, facilityOrderTemplates: val });
                }
                index++;
            });
        }
        else {
            _.each(groupByPatient, (val, key,) => {
                let facilityOrderPatient = this.facilityOrderPatients.find(x => x.patientId == key);
                this.facilityOrderTemplatesGroupByPatient.push({ id: `${this.selectedStatusAbrv}-${key}-${uuid()})`, facilityOrderPatient: facilityOrderPatient, facilityOrderTemplates: val });
            });
        }

        this.hasMore = this.totalRecords > this.facilityOrderTemplatesGroupByPatient.length;
        this.isLoadMore = false;

        if (this.checkIsEmpty()) {
            await this.checkIsReviewed();
        }
        
        if (showInfoMessage && this.facilityOrderTemplatesGroupByPatient.length === 0) {
            this.rootStore.notificationStore.warning("No templates found under selected filter");
        }

        this.loadingTemplates = false;
    }

    @action.bound
    loadMore() {
        if (this.selectedStatusAbrv == "in-progress") {
            if (this.hasMore && !this.isLoadMore) {
                this.hasMore = false;
                this.isLoadMore = true;
                this.queryUtility.fetch();
            }
        }
    }

    @action.bound
    hasPatientInsuranceQuestion(patientId) {
        const facilityOrderPatient = this.facilityOrderPatients.find(x => x.patientId == patientId);
        return facilityOrderPatient && facilityOrderPatient.insuranceQuestion && facilityOrderPatient.insuranceQuestion !== "";
    }

    @action.bound
    async hasAnyTemplateInProgress() {
        let statusIds = _.map(_.filter(this.lookups.newFlowStatus, s => s.abrv === "in-progress" || s.abrv === "change" || s.abrv === "no-change" || s.abrv === "new-order"), (s => { return s.id }));
        let params = {
            newFlowUSIntakeStatusIds: statusIds.join(","),
            pageSize: 1,
            facilityOrderId: this.id,
            fields: 'id',
            itemCategoryIds: this.facilityOrder.isEnteralWeek ? [this.enteralItemCategoryId] : undefined,
            masterPatientId: this.facilityOrder.isEnteralWeek ? this.masterPatientId : undefined
        }
        const response = await this.facilityOrderTemplateService.find(params);
        return response.data.item && response.data.item.some(x => x.id);
    }

    @action.bound
    async signalRAction(message) {
        if (message.table == "FO") {
            if (message.column == "SendOrder") {
                this.facilityOrder.sendOrder = true;
            }
            else {
                this.disabled = true;
                this.loadingTemplates = true;
                this.facilityOrderTemplatesGroupByPatient = [];
                await this.fetchAllFacilityOrderTemplates();
                this.disabled = false;
            }
        }
        else if (message.table == "FOT" || message.table == "FOTI" || message.table == "FOP") {
            if (message.id == this.id && !message.patientId) {
                this.disabled = true;
                this.facilityOrderTemplatesGroupByPatient = [];
                this.loadingTemplates = true;
                await this.fetchAllFacilityOrderTemplates();
                this.disabled = false;
            }
            else if (message.patientId) {
                await this.reloadFacilityOrderPatientAndTemplates(message.patientId);
            }
            else {
                if (message.table == "FOP") {
                    await this.reloadFacilityOrderPatient(message.id);
                }
                else {
                    await this.reloadFacilityOrderTemplate(message.id);
                }
            }
        }
        else if (message.table == "P") {
            await this.reloadFacilityOrderTemplatePatient(message.patientId);
        }
        else if (message.table == "PTH") {
            this.initializePickTicketHeader();
        }
        else if (message.table == "FOS") {
            await this.getFacilityOrderStatus();
            if (this.checkIsEmpty()) {
                await this.checkIsReviewed();
            }
        }
    }

    @action.bound
    async reloadFacilityOrderTemplatePatient(patientId) {
        if (patientId && this.allFacilityOrderTemplates && this.allFacilityOrderTemplates.some(x => x.patientId == patientId)) {
            let response = (await this.localPatientService.get(patientId)).data;
            var templates = this.allFacilityOrderTemplates.filter(x => x.patientId == patientId);
            _.each(templates, template => {
                Object.keys(template.patient).forEach(key => {
                    template.patient[key] = response[key];
                });
            });
        }
    }

    @action.bound
    async reloadFacilityOrderPatientAndTemplates(patientId) {
        this.loadingTemplates = true;
        let facilityOrderPatient = (await this.facilityOrderPatientService.find({ rpp: 1, facilityOrderId: this.facilityOrder.id, patientId: patientId, embed: "EligibilityStatus,FacilityOrderPatientInitial,FacilityOrderPatientInitial.EligibilityStatus" })).data.item;
        if (!facilityOrderPatient || facilityOrderPatient.length == 0) {
            this.allFacilityOrderTemplates = this.allFacilityOrderTemplates.filter(x => x.patientId !== patientId);
            this.facilityOrderPatients = this.facilityOrderPatients.filter(x => x.patientId != patientId);
            this.facilityOrderTemplatesGroupByPatient = [];
            this.queryUtility.fetch();
            return;
        }
        else {
            await this.reloadFacilityOrderPatient(facilityOrderPatient[0].id, facilityOrderPatient[0]);
        }

        let params = {
            pageSize: 10000,
            facilityOrderId: this.id,
            patientId: patientId,
            embed: 'FacilityOrderTemplateInitial,FacilityOrderTemplateInitial.OrderingDoctor,FacilityOrderTemplateInitial.ClinicalStatus,FacilityOrderTemplateItems,Patient,SubCategory,ItemCategory,ImportReference,NewFlowStatus,NewFlowInsuranceStatus,NewFlowUSIntakeStatus,ReviewUSIntakeValidations,FacilityOrderTemplateMissingDocuments,FacilityOrderTemplateMissingDocumentInitials,OrderingDoctor,ClinicalStatus,IsFacilityOrderTemplateItemInitial,ImportDetailStatus',
            orderBy: "SubCategory",
            orderDirection: "asc",
        }

        let items = (await this.facilityOrderTemplateService.find(params)).data.item;
        let patientFacilityOrderTemplates = _.map(items, (template) => {
            return {
                ...template,
                itemsVisible: template.inactiveReasonId === 58 ? true : false
            };
        });

        if (patientFacilityOrderTemplates.length == 0) {
            this.allFacilityOrderTemplates = this.allFacilityOrderTemplates.filter(x => x.patientId !== patientId);
            this.facilityOrderPatients = this.facilityOrderPatients.filter(x => x.patientId != patientId);
            this.facilityOrderTemplatesGroupByPatient = [];
            this.queryUtility.fetch();
            return;
        }

        let patientTemplates = this.allFacilityOrderTemplates.filter(x => x.patientId === patientId);
        const index = this.allFacilityOrderTemplates.findIndex(x => x.patientId === patientId);
        if (index == -1) {
            _.each(patientFacilityOrderTemplates, template => {
                this.allFacilityOrderTemplates.push(template);
            });
            this.allFacilityOrderTemplates = _.orderBy(this.allFacilityOrderTemplates, ['patient.lastName', 'patient.firstName', 'templateId'], ['asc', 'asc', 'asc']);
        }
        else {
            _.each(patientFacilityOrderTemplates, template => {
                if (patientTemplates.some(x => x.id == template.id)) {
                    this.reloadFacilityOrderTemplate(template.id, template);
                }
            });
            _.each(patientTemplates, patientTemplate => {
                if (!patientFacilityOrderTemplates.some(x => x.id == patientTemplate.id)) {
                    const patientTemplateIndex = this.allFacilityOrderTemplates.findIndex(x => x.id === patientTemplate.id);
                    this.allFacilityOrderTemplates.splice(patientTemplateIndex, 1);
                }
            });
            _.each(patientFacilityOrderTemplates, template => {
                if (!patientTemplates.some(x => x.id == template.id)) {
                    this.allFacilityOrderTemplates.push(template);
                }
            });
        }

        const newFlowUSIntakeStatusIds = this.queryUtility.filter.newFlowUSIntakeStatusIds.split(",");
        const itemCategoryIds = this.facilityOrder.isEnteralWeek ? [this.enteralItemCategoryId] : _.map(this.itemCategories, (i => { return i.id }));
        const showInsuranceQuestionPatients = this.selectedStatusAbrv != "discharge" && this.selectedQuestions.some(x => x.id === "0");
        const showMissingProductTemplates = this.selectedStatusAbrv != "discharge" && this.selectedQuestions.some(x => x.id === "1");
        let filteredTemplates =
            this.allFacilityOrderTemplates.filter(t =>
                t.patientId === patientId &&
                newFlowUSIntakeStatusIds.includes(t.newFlowUSIntakeStatusId) &&
                (itemCategoryIds.length == 0 || itemCategoryIds.includes(t.itemCategoryId) || this.masterPatientId == t.patientId) &&
                (!showInsuranceQuestionPatients || this.hasPatientInsuranceQuestion(t.patientId)) &&
                (!showMissingProductTemplates || t.missingProduct)
            );

        const groupIndex = this.facilityOrderTemplatesGroupByPatient.findIndex(x => x.id.includes(`${this.selectedStatusAbrv}-${patientId}`));
        if (groupIndex == -1) {
            this.facilityOrderTemplatesGroupByPatient = [];
            this.queryUtility.fetch();
            return;
        }
        else {
            this.facilityOrderTemplatesGroupByPatient = this.facilityOrderTemplatesGroupByPatient.filter(x => !x.id.includes(`${this.selectedStatusAbrv}-${patientId}`));
            if (filteredTemplates && filteredTemplates.length > 0 && groupIndex !== -1) {
                let facilityOrderPatient = this.facilityOrderPatients.find(x => x.patientId == patientId);
                this.facilityOrderTemplatesGroupByPatient.splice(groupIndex, 0, { id: `${this.selectedStatusAbrv}-${patientId}-${uuid()}`, facilityOrderPatient: facilityOrderPatient, facilityOrderTemplates: filteredTemplates });
            }
        }

        if (this.checkIsEmpty()) {
            await this.checkIsReviewed();
        }

        this.loadingTemplates = false;
    }

    @action.bound
    async reloadFacilityOrderPatient(facilityOrderPatientId, facilityOrderPatient) {
        if (facilityOrderPatientId && this.facilityOrderPatients) {
            let response = facilityOrderPatient;
            if (!response) {
                response = (await this.facilityOrderPatientService.get(facilityOrderPatientId, { embed: "EligibilityStatus,FacilityOrderPatientInitial,FacilityOrderPatientInitial.EligibilityStatus" })).data;
            }
            var patient = this.facilityOrderPatients.find(x => x.id == facilityOrderPatientId);
            if (patient) {
                Object.keys(patient).forEach(key => {
                    patient[key] = response[key];
                });
            }
            else {
                this.facilityOrderPatients.push(patient);
            }
        }
    }

    @action.bound
    async reloadFacilityOrderTemplate(facilityOrderTemplateId, facilityOrderTemplate) {
        if (facilityOrderTemplateId && this.allFacilityOrderTemplates && this.allFacilityOrderTemplates.some(x => x.id == facilityOrderTemplateId)) {
            let response = facilityOrderTemplate;
            if (!response) {
                response = (await this.facilityOrderTemplateService.get(facilityOrderTemplateId, { embed: 'FacilityOrderTemplateInitial,FacilityOrderTemplateInitial.OrderingDoctor,FacilityOrderTemplateInitial.ClinicalStatus,FacilityOrderTemplateItems,Patient,SubCategory,ItemCategory,ImportReference,NewFlowStatus,NewFlowInsuranceStatus,NewFlowUSIntakeStatus,ReviewUSIntakeValidations,FacilityOrderTemplateMissingDocuments,FacilityOrderTemplateMissingDocumentInitials,OrderingDoctor,ClinicalStatus,IsFacilityOrderTemplateItemInitial,ImportDetailStatus' })).data;
            }
            var template = this.allFacilityOrderTemplates.find(x => x.id == facilityOrderTemplateId);
            if (template) {
                Object.keys(template).forEach(key => {
                    template[key] = response[key];
                });
            }
            else {
                this.allFacilityOrderTemplates.push(template);
            }
        }
    }

    @action.bound
    async downloadFacilityOrder() {
        const downloadUrl = `${(await this.facilityOrderTemplateService.getDownloadNewFlowUrl({ facilityOrderId: this.facilityOrder.id }))}&contentDisposition=attachment&token=${this.rootStore.authStore.token.tokenUrl}&ttype=${this.rootStore.authStore.token.type}`
        window.open(downloadUrl, "_blank")
    }
    
    @action.bound
    async downloadFacilityOrderCsv() {
        const downloadUrl = `${(await this.facilityOrderTemplateService.getDownloadNewFlowCsvUrl({ ...this.queryUtility.plainFilter, facilityOrderId: this.facilityOrder.id }))}&contentDisposition=attachment&token=${this.rootStore.authStore.token.tokenUrl
            }&ttype=${this.rootStore.authStore.token.type}`
        window.open(downloadUrl, "_blank")
    }

    @action.bound
    downloadInventoryReport() {
        const facilityInventoryCountDetailService = new FacilityInventoryCountDetailService(this.rootStore.application.baasic.apiClient);
        const downloadUrl = `${facilityInventoryCountDetailService.getDownloadInventoryReportUrl({ facilityOrderId: this.facilityOrder.id })}&contentDisposition=attachment&token=${this.rootStore.authStore.token.tokenUrl}&ttype=${this.rootStore.authStore.token.type}`;
        window.open(downloadUrl, "_blank");
    }

    @action.bound
    filterByQuestion(selected) {
        this.selectedQuestions = selected.value;
        this.filterChange = true;
        this.queryUtility.fetch();
    }

    @action.bound
    filterByCategory(selected) {
        this.itemCategories = selected.value;
        this.filterChange = true
        this.queryUtility.fetch();
    }

    @action.bound
    goToCreatePatient() {
        this.rootStore.routerStore.goTo('master.app.main.facility-order.facility-order-new-flow.us-intake-create-patient', {
            id: this.facilityOrder.id
        });
    }

    @action.bound
    async openFacilityOrderNewFlowUSIntakeFindAndReplaceModal() {
        let errorMessage = null;
        if (this.facilityOrder.pickTicketHeaderId) {
            const pickTicketHeaderService = new PickTicketHeaderService(this.rootStore.application.baasic.apiClient);
            const pickTicketHeader = (await pickTicketHeaderService.get(this.facilityOrder.pickTicketHeaderId, { embed: "pickTicketHeaderStatus", fields: "pickTicketHeaderStatus" })).data;
            if (pickTicketHeader && pickTicketHeader.pickTicketHeaderStatus && pickTicketHeader.pickTicketHeaderStatus.abrv != "new") {
                errorMessage = pickTicketHeader.pickTicketHeaderStatus.abrv == "in-progress" ? "This action is not allowed because purchasing is in progress." : "This action is not allowed because purchasing is complete.";
            }
        }
        if (errorMessage) {
            this.rootStore.notificationStore.error(errorMessage);
            return;
        }
        this.facilityOrderNewFlowUSIntakeFindAndReplaceModal.open({
            facilityOrderId: this.facilityOrder.id,
            fetchData: async () => { this.facilityOrderTemplatesGroupByPatient = []; await this.fetchAllFacilityOrderTemplates() }
        });
    }

    @action.bound
    async setUSIntakeStatus(completed) {
        if (completed) {
            await this.setUSIntakeCompleted();
        }
        else {
            await this.getFacilityOrderStatus();
            const insuranceReviewStatus = this.facilityOrder.facilityOrderStatuses.find(i => i.status.abrv === 'insurance-review');
            const initialIntakeStatus = this.facilityOrder.facilityOrderStatuses.find(i => i.status.abrv === 'initial-intake');
            if (!(initialIntakeStatus && initialIntakeStatus.completedOn) || !(insuranceReviewStatus && insuranceReviewStatus.completedOn)) {
                this.statusConfirmModal.open({
                    message: !(initialIntakeStatus && initialIntakeStatus.completedOn) ? "This facility order has not been completed by the Initial Intake and the Insurance Review departments. Once you start US Intake, they will no longer be able to access their workflow." : "This facility order has not been completed by the Insurance Review department. Once you start US Intake, they will no longer be able to access their workflow."
                });
            }
            else {
                await this.setUSIntakeStarted();
            }
        }
    }

    @action.bound
    async getFacilityOrderStatus() {
        var statusesResponse = await this.facilityOrderStatusService.find({ facilityOrderId: this.facilityOrder.id, embed: "Status,StartedByUser,CompletedByUser" });
        this.facilityOrder.facilityOrderStatuses = statusesResponse.data && statusesResponse.data.item;
        this.facilityOrderStatus = this.facilityOrder.facilityOrderStatuses.find(i => i.status.abrv === 'us-intake');
        this.disabled = !(this.facilityOrderStatus && this.facilityOrderStatus.startedOn);
        this.changeStatusBarVisibility();
        this.changeStatusBarVisibility();
    }

    @action.bound
    changeStatusBarVisibility() {
        this.isStatusBarVisible = !this.isStatusBarVisible;
    }

    @action.bound
    async setUSIntakeStarted() {
        try {
            if (this.facilityOrderStatus) {
                return;
            }

            const initialIntakeStatus = this.facilityOrder.facilityOrderStatuses.find(i => i.status.abrv === 'initial-intake');
            if (initialIntakeStatus && !initialIntakeStatus.completedOn) {
                var result = await this.facilityOrderTemplateService.updateFacilityOrderTemplateIntakeStatuses({ facilityOrderId: this.facilityOrder.id });
                if (result.statusCode === 200) {
                    await this.fetchAllFacilityOrderTemplates();
                }
            }

            const status = this.lookups.importHeaderStatus.find(i => i.abrv === 'us-intake');
            await this.facilityOrderStatusService.create({ facilityOrderId: this.facilityOrder.id, statusId: status.id, startedOn: new Date(), startedByUserId: this.rootStore.userStore.user.id });
            await this.getFacilityOrderStatus();

            if (this.checkIsEmpty()) {
                await this.checkIsReviewed();
            }
        }
        catch (err) {
            this.rootStore.notificationStore.error("The facility order status has already been updated. Please reload the page.");
        }
    }

    @action.bound
    async setUSIntakeCompleted() {
        try {
            if (!this.facilityOrderStatus || this.facilityOrderStatus.completedOn) {
                return;
            }

            const request = { ...this.facilityOrderStatus, completedOn: new Date(), completedByUserId: this.rootStore.userStore.user.id };
            await this.facilityOrderStatusService.update(request);
            await this.getFacilityOrderStatus();
            await this.openClinicalReviewPage();

            if (this.checkIsEmpty()) {
                await this.checkIsReviewed();
            }
        }
        catch (err) {
            this.rootStore.notificationStore.error("The facility order status has already been updated. Please reload the page.");
        }
    }

    @action.bound
    async openClinicalReviewPage() {
        const personService = new PersonService(this.rootStore.application.baasic.apiClient);
        const person = (await personService.getByUser(this.rootStore.userStore.user.id)).data;

        const scheduleService = new ScheduleService(this.rootStore.application.baasic.apiClient);
        let params = {
            pageSize: 1,
            calendarTypeId: _.find(this.lookups.facilityScheduleType, s => { return s.abrv === 'ordering'; }).id,
            facilityOrderId: this.facilityOrder.id,
            documentRepId: person.id,
            fields: "id"
        }
        const response = await scheduleService.find(params);
        if (response.data && response.data.item && response.data.item.some(i => i)) {
            window.open(this.rootStore.routerStore.findRoute("master.app.main.facility-order.facility-order-new-flow.clinical-preview").pattern.replace(":id", this.facilityOrder.id));
        }
    }

    @action.bound
    checkIsEmpty() {
        this.isEmpty = (!this.itemCategories || this.itemCategories.length == 0) && !this.selectedQuestions.some(x => x) && this.facilityOrderStatus && !this.facilityOrderStatus.completedOn && this.selectedStatusAbrv == "in-progress" && !this.hasMore && !this.facilityOrderTemplatesGroupByPatient.some(i => i.facilityOrderTemplates && i.facilityOrderTemplates.some(j => j));
        return this.isEmpty;
    }

    @action.bound
    async checkIsReviewed() {
        let params = {
            pageSize: 1,
            facilityOrderId: this.id,
            isReviewed: false,
            fields: "id"
        }

        if (this.facilityOrder.isEnteralWeek) {
            params = _.extend(params, {
                itemCategoryIds: [this.enteralItemCategoryId],
                masterPatientId: this.masterPatientId
            });
        }

        const response = await this.facilityOrderTemplateService.find(params);
        this.isReviewed = response.data.item && !response.data.item.some(i => i);
    }

    @action.bound
    async reviewAllDischargeTemplates() {
        try {
            this.disabled = true;
            const templates = this.facilityOrderTemplatesGroupByPatient.reduce((result, item) => {
                if (item && item.facilityOrderTemplates) {
                    result = result.concat(item.facilityOrderTemplates.filter(obj => obj !== undefined && !obj.isReviewed));
                }
                return result;
            }, []);

            if (templates && templates.length > 0) {

                templates.forEach(template => {
                    template.isReviewed = true;
                });

                await this.facilityOrderTemplateService.batchUpdate(templates);
                this.checkIsReviewed();
                this.queryUtility.fetch();
            }

        } catch (err) {
            this.rootStore.notificationStore.error("An unexpected error occurred while trying to update the template.", err);
        }
        this.disabled = false;
    }

    @action.bound
    async fetchTemplatePartialData(patientId, templateId, remove) {
        let params = {
            pageSize: 10000,
            facilityOrderId: this.id,
            patientId: patientId,
            embed: 'NewFlowStatus,NewFlowUSIntakeStatus,ClinicalStatus',
            fields: 'Id,IsClinicalReviewed,IsReviewed,NewFlowStatusId,NewFlowStatus,NewFlowUSIntakeStatusId,NewFlowUSIntakeStatus,InactiveReasonId,InactiveReason,ClinicalStatusId,ClinicalStatus,ClinicalStatusNote,Note,IsPriorAuthNeeded'
        }
        if (templateId) {
            _.extend(params, { ids: [templateId] })
        }
        let newItems = (await this.facilityOrderTemplateService.find(params)).data.item;
        this.allFacilityOrderTemplates.filter(t => t.patientId === patientId && (!templateId || t.id === templateId))
            .forEach(item => {
                var newItem = newItems.find(i => i.id === item.id);
                if (newItem) {
                    item.isClinicalReviewed = newItem.isClinicalReviewed;
                    item.isReviewed = newItem.isReviewed;
                    item.newFlowStatusId = newItem.newFlowStatusId;
                    item.newFlowStatus = newItem.newFlowStatus;
                    item.newFlowUSIntakeStatusId = newItem.newFlowUSIntakeStatusId;
                    item.newFlowUSIntakeStatus = newItem.newFlowUSIntakeStatus;
                    item.inactiveReasonId = newItem.inactiveReasonId;
                    item.inactiveReason = newItem.inactiveReason;
                    item.clinicalStatusId = newItem.clinicalStatusId;
                    item.clinicalStatus = newItem.clinicalStatus;
                    item.clinicalStatusNote = newItem.clinicalStatusNote;
                    item.note = newItem.note;
                    item.isPriorAuthNeeded = newItem.isPriorAuthNeeded;
                }
            });

        if (remove) {
            if (templateId) {
                var group = this.facilityOrderTemplatesGroupByPatient.find(x => x.id.includes(`${this.selectedStatusAbrv}-${patientId}`));
                if (group && group.facilityOrderTemplates) {
                    if (group.facilityOrderTemplates.some(x => x.id != templateId)) {
                        group.facilityOrderTemplates = group.facilityOrderTemplates.filter(x => x.id != templateId);
                    }
                    else {
                        this.facilityOrderTemplatesGroupByPatient = this.facilityOrderTemplatesGroupByPatient.filter(x => !x.id.includes(`${this.selectedStatusAbrv}-${patientId}`));
                        this.totalRecords -= 1;
                    }
                }
            }
            else {
                this.facilityOrderTemplatesGroupByPatient = this.facilityOrderTemplatesGroupByPatient.filter(x => !x.id.includes(`${this.selectedStatusAbrv}-${patientId}`));
                this.totalRecords -= 1;
            }
            if(this.totalRecords === 0)
            {
                this.showLoader = false;
            }
            this.loadFacilityOrderPatient();
            this.isReviewed = undefined;
            this.hasMore = this.totalRecords > this.facilityOrderTemplatesGroupByPatient.length;
            if (this.checkIsEmpty()) {
                await this.checkIsReviewed();
            }
            this.checkIsUSIntakeCompleted();
        }
    }

    @action.bound
    async fetchFacilityOrderTemplatesByPatient(patientId) {
        let params = {
            pageSize: 10000,
            facilityOrderId: this.id,
            patientId: patientId,
            embed: 'FacilityOrderTemplateInitial,FacilityOrderTemplateInitial.OrderingDoctor,FacilityOrderTemplateInitial.ClinicalStatus,FacilityOrderTemplateItems,Patient,SubCategory,ItemCategory,ImportReference,NewFlowStatus,NewFlowInsuranceStatus,NewFlowUSIntakeStatus,ReviewUSIntakeValidations,FacilityOrderTemplateMissingDocuments,FacilityOrderTemplateMissingDocumentInitials,OrderingDoctor,ClinicalStatus,IsFacilityOrderTemplateItemInitial,ImportDetailStatus',
            orderBy: "SubCategory",
            orderDirection: "asc",
        }

        let items = (await this.facilityOrderTemplateService.find(params)).data.item;
        let patientFacilityOrderTemplates = _.map(items, (template) => {
            return {
                ...template,
                itemsVisible: template.inactiveReasonId === 58 ? true : false
            };
        });

        const index = this.allFacilityOrderTemplates.findIndex(x => x.patientId === patientId);
        if (index !== -1) {
            this.allFacilityOrderTemplates = this.allFacilityOrderTemplates.filter(x => x.patientId !== patientId);
            if (patientFacilityOrderTemplates && patientFacilityOrderTemplates.length > 0) {
                this.allFacilityOrderTemplates.splice(index, 0, ...patientFacilityOrderTemplates);
            }
        }

        const newFlowUSIntakeStatusIds = this.queryUtility.filter.newFlowUSIntakeStatusIds.split(",");
        const itemCategoryIds = this.facilityOrder.isEnteralWeek ? [this.enteralItemCategoryId] : _.map(this.itemCategories, (i => { return i.id }));
        const showInsuranceQuestionPatients = this.selectedStatusAbrv != "discharge" && this.selectedQuestions.some(x => x.id === "0");
        const showMissingProductTemplates = this.selectedStatusAbrv != "discharge" && this.selectedQuestions.some(x => x.id === "1");
        let filteredTemplates =
            this.allFacilityOrderTemplates.filter(t =>
                t.patientId === patientId &&
                newFlowUSIntakeStatusIds.includes(t.newFlowUSIntakeStatusId) &&
                (itemCategoryIds.length == 0 || itemCategoryIds.includes(t.itemCategoryId) || this.masterPatientId == t.patientId) &&
                (!showInsuranceQuestionPatients || this.hasPatientInsuranceQuestion(t.patientId)) &&
                (!showMissingProductTemplates || t.missingProduct)
            );

        const groupIndex = this.facilityOrderTemplatesGroupByPatient.findIndex(x => x.id.includes(`${this.selectedStatusAbrv}-${patientId}`));
        this.facilityOrderTemplatesGroupByPatient = this.facilityOrderTemplatesGroupByPatient.filter(x => !x.id.includes(`${this.selectedStatusAbrv}-${patientId}`));
        if (filteredTemplates && filteredTemplates.length > 0 && groupIndex !== -1) {
            let facilityOrderPatient = this.facilityOrderPatients.find(x => x.patientId == patientId);
            this.facilityOrderTemplatesGroupByPatient.splice(groupIndex, 0, { id: `${this.selectedStatusAbrv}-${patientId}-${uuid()}`, facilityOrderPatient: facilityOrderPatient, facilityOrderTemplates: filteredTemplates });
        }
        else {
            this.loadFacilityOrderPatient();
        }

        if (this.checkIsEmpty()) {
            await this.checkIsReviewed();
        }
    }

    @action.bound
    loadFacilityOrderPatient() {
        if (this.selectedStatusAbrv != "in-progress" || !this.hasMore) {
            return;
        }

        const newFlowUSIntakeStatusIds = this.queryUtility.filter.newFlowUSIntakeStatusIds.split(",");
        const itemCategoryIds = this.facilityOrder.isEnteralWeek ? [this.enteralItemCategoryId] : _.map(this.itemCategories, (i => { return i.id }));
        const showInsuranceQuestionPatients = this.selectedQuestions.some(x => x.id === "0");
        const showMissingProductTemplates = this.selectedQuestions.some(x => x.id === "1");

        let filterTemplates =
            this.allFacilityOrderTemplates.filter(t =>
                newFlowUSIntakeStatusIds.includes(t.newFlowUSIntakeStatusId) &&
                (itemCategoryIds.length == 0 || itemCategoryIds.includes(t.itemCategoryId) || this.masterPatientId == t.patientId) &&
                (!showInsuranceQuestionPatients || this.hasPatientInsuranceQuestion(t.patientId)) &&
                (!showMissingProductTemplates || t.missingProduct)
            );

        let groupByPatient = _.groupBy(filterTemplates, 'patientId');
        let index = 0;
        const indexStart = this.facilityOrderTemplatesGroupByPatient.length;
        const indexEnd = indexStart + 1;
        _.each(groupByPatient, (val, key) => {
            if (index >= indexStart && index < (indexEnd)) {
                let facilityOrderPatient = this.facilityOrderPatients.find(x => x.patientId == key);
                this.facilityOrderTemplatesGroupByPatient.push({ id: `${this.selectedStatusAbrv}-${key}-${uuid()}`, facilityOrderPatient: facilityOrderPatient, facilityOrderTemplates: val });
            }
            index++;
        });
    }

    @action.bound
    checkIsUSIntakeCompleted() {
        if (this.isEmpty && this.selectedStatusAbrv == "in-progress" && !this.isReviewed) {
            this.setStatus('discharge');
        }
    }

	@action.bound
	orderHistory() {
        window.open(this.rootStore.routerStore.findRoute("master.app.main.facility-order.facility-order-new-flow.history").pattern.replace(":id", this.facilityOrder.id));
    }

    @action.bound
    async goToFacilityPreview() {
        window.open(`${this.rootStore.routerStore.findRoute('master.app.main.facility.preview').pattern.replace(":id", this.facilityOrder.facilityId)}`);
    }

    @action.bound
    async goToFacilityCalendar() {
        window.open(`${this.rootStore.routerStore.findRoute('master.app.main.schedule.calendar').pattern}?facilityId=${this.facilityOrder.facilityId}&calendarTypeId=${this.orderType.id}`);
    }

}

export default FacilityOrderNewFlowUSIntakeSinglePagePreviewViewStore;